var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.939,15.054a.623.623,0,0,1-.626-.624V6.083a.623.623,0,0,1,.626-.626H21.4a.589.589,0,0,1,.6.626v8.346a.623.623,0,0,1-.626.624Zm-12.193,0a.623.623,0,0,1-.626-.624V6.083a.623.623,0,0,1,.626-.626H9.18a.623.623,0,0,1,.626.626v8.346a.623.623,0,0,1-.626.624Zm-6.121,0A.623.623,0,0,1,0,14.429v-4.8A.624.624,0,0,1,.626,9H3.083a.59.59,0,0,1,.6.626v4.8a.623.623,0,0,1-.626.624Zm12.217-.021a.623.623,0,0,1-.626-.626V8.193a.623.623,0,0,1,.626-.626h2.434a.629.629,0,0,1,.627.649v6.19a.623.623,0,0,1-.626.626ZM.395,5.109a1.07,1.07,0,0,1,.44-1.437L7.464.125A1.109,1.109,0,0,1,8.322.056l5.772,2.017L20.376.056a1.1,1.1,0,0,1,1.345.695,1.1,1.1,0,0,1-.7,1.345L14.395,4.228a1.1,1.1,0,0,1-.672,0L8.067,2.257,1.854,5.573a1.345,1.345,0,0,1-.51.116A1.048,1.048,0,0,1,.395,5.109Z",
    transform: "translate(1 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/icon-data.baa7aed6.svg";
export { ForwardRef as ReactComponent };